const toast = (function() {
    function getToastContainer() {
        let containerElement = document.getElementById('toast-container');

        if (!containerElement) {
            containerElement = document.createElement('div');
            containerElement.id = 'toast-container';

            Object.assign(containerElement.style, {
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                zIndex: 10000,
                marginLeft: '20px'
            });

            document.body.appendChild(containerElement);
        }

        return containerElement;
    }

    function show(message, milliseconds, type = 'Default') {
        const containerElement = getToastContainer();

        if (containerElement.children.length >= 5) {
            containerElement.removeChild(containerElement.lastChild);
        }

        const toastElement = document.createElement('div');
        toastElement.innerText = message;
        toastElement.classList.add('toast', type.toLowerCase());

        Object.assign(toastElement.style, {
            backgroundColor: '#333',
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            opacity: '0',
            transition: 'opacity 0.5s, transform 0.5s',
            transform: 'translateY(-10px)',
            FontSize: '14px !important'
        });

        switch (type.toLowerCase()) {
            case 'success':
                toastElement.style.backgroundColor = '#28a745';
            break;
            case 'alert':
                toastElement.style.backgroundColor = '#004aa9';
                toastElement.style.color = '#FFF';
            break;
            case 'error':
                toastElement.style.backgroundColor = '#dc3545';
            break;
        }

        containerElement.insertBefore(toastElement, containerElement.firstChild);

        requestAnimationFrame(() => {
            toastElement.style.opacity = '1';
            toastElement.style.transform = 'translateY(0)';
        });

        setTimeout(() => {
            toastElement.style.opacity = '0';
            toastElement.style.transform = 'translateY(-10px)';
            toastElement.addEventListener('transitionend', () => {
                toastElement.remove();
            });
        }, milliseconds);
    }

    return { show };
}());
